import { isObject } from "./object";
export const isUndefined = (param) => param === undefined;
export const isNullOrUndefined = (param) =>
  isUndefined(param) || param === null;
export const isDefined = (param) => !isNullOrUndefined(param);

export const isString = (param) =>
  Object.prototype.toString.call(param) === "[object String]";

export const isArray = (param) => Array.isArray(param);

export const isEmpty = (param) => {
  if (isString(param) || isArray(param)) {
    return param.length === 0;
  }

  if (isObject(param)) {
    return Object.keys(param).length === 0;
  }

  return false;
};

export const isConsideredEmptyString = (str) => {
  return !isString(str) || isEmpty(str.trim());
};
